<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-sm alert">
				<div class="modal-header p-0 clearfix">
					<a class="close" @click="config.show = false">×</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body p-10 clearfix">
					<button class="btn lg-btn half-width center-block round m-t-30 m-b-15">이어서 등록</button>
					<button class="btn lg-btn half-width center-block round m-b-30">등록 마침</button>
				</div>
				<!-- //end .modal-body -->
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalClassSurveyDirect",

	default: function() {
		return {
			show: false
		}
	},
	data (){
		return  {

		}
	},

	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>